import React from "react";
import StatusBadge from "./StatusBadge";

const PaymentMethodsTable = ({ paymentMethods, onEdit, onDelete, onToggleStatus }) => {
  if (paymentMethods.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-gray-500 text-lg mb-4">No payment methods found</p>
        <p className="text-gray-400">Click "Add New Method" to create your first payment method</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
      <table className="w-full border-collapse bg-white">
        <thead>
          <tr className="bg-gray-50 text-gray-700">
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Logo</th>
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Name</th>
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Type</th>
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Description</th>
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Status</th>
            <th className="border border-gray-200 px-4 py-3 text-left font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {paymentMethods.map((method, index) => (
            <PaymentMethodRow
              key={method._id}
              method={method}
              onEdit={onEdit}
              onDelete={onDelete}
              onToggleStatus={onToggleStatus}
              isEven={index % 2 === 0}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const PaymentMethodRow = ({ method, onEdit, onDelete, onToggleStatus, isEven }) => {
  const getTypeBadge = (type) => {
    const typeConfig = {
      deposit: { color: "bg-blue-100 text-blue-800", text: "Deposit" },
      withdrawal: { color: "bg-green-100 text-green-800", text: "Withdrawal" },
      both: { color: "bg-purple-100 text-purple-800", text: "Both" }
    };
    
    const config = typeConfig[type] || typeConfig.deposit;
    
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
        {config.text}
      </span>
    );
  };

  return (
    <tr className={`border border-gray-200 ${isEven ? 'bg-white' : 'bg-gray-50'} hover:bg-gray-100 transition-colors`}>
      <td className="border border-gray-200 px-4 py-3">
        <span className="text-2xl">{method.logo}</span>
      </td>
      
      <td className="border border-gray-200 px-4 py-3">
        <div className="font-semibold text-gray-800">{method.name}</div>
      </td>
      
      <td className="border border-gray-200 px-4 py-3">
        {getTypeBadge(method.type)}
      </td>
      
      <td className="border border-gray-200 px-4 py-3 text-gray-600">
        {method.description}
      </td>
      
      <td className="border border-gray-200 px-4 py-3">
        <StatusBadge status={method.isActive ? "active" : "inactive"} />
      </td>
      
      <td className="border border-gray-200 px-4 py-3">
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(method)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors shadow-sm"
          >
            Edit
          </button>
          <button
            onClick={() => onToggleStatus(method)}
            className={`${
              method.isActive 
                ? 'bg-amber-600 hover:bg-amber-700' 
                : 'bg-green-600 hover:bg-green-700'
            } text-white px-3 py-1 rounded text-sm font-medium transition-colors shadow-sm`}
          >
            {method.isActive ? 'Disable' : 'Enable'}
          </button>
          <button
            onClick={() => onDelete(method)}
            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors shadow-sm"
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
};

export default PaymentMethodsTable;